export default {"src":"/_next/static/media/BNS.387a1526.svg","height":18,"width":18};